import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import "./VesselsValueOptIn.css";
import { Dialog } from "primereact/dialog";
import {
    Buttons,
    FirstParagraph,
    LearnMoreContent,
    LearnMoreTerms,
    Title
} from "./SubComponents";
import { Panel } from "primereact/panel";
import { IdwalSvgWhite } from "./Svgs";

export interface VesselsValueOptInProps {
    agreeCallback: () => void;
    declineCallback: () => void;
    visible: boolean;
}

export const VesselsValueOptIn = (props: VesselsValueOptInProps) => {
    const { t } = useTranslation("common");
    const ref = useRef<Panel>(null);

    return (
        <Dialog
            maskClassName="vesselsValueOptIn__mask"
            className={"shadow-none text-sm overflow-scroll"}
            onHide={() => {
                return;
            }}
            visible={props.visible}
            blockScroll={true}
            position={"bottom"}
            content={
                <div id={"vesselsValueOptIn__card"}>
                    <div className={"grid h-full"}>
                        <div className={"col-12 md:col-2 md:text-center"}>
                            {IdwalSvgWhite}
                        </div>

                        <p
                            className={
                                "col-12 md:col-10 text-sm vesselsValueOptIn__text"
                            }
                        >
                            {Title(t)}
                            {FirstParagraph(t)}
                        </p>
                        <div
                            className={
                                "col-12 hidden md:inline md:col-2 align-items-center text-center p-0"
                            }
                        >
                            <></>
                        </div>
                        <div
                            className={
                                "col-12 md:col-10 flex flex-column pt-0 "
                            }
                        >
                            <Panel
                                id="vesselsValueOptIn__accordionPanel"
                                ref={ref}
                                toggleable
                                collapsed={false}
                                headerTemplate={<></>}
                            >
                                {LearnMoreContent(t)}

                                <div className="pb-4">{LearnMoreTerms(t)}</div>
                            </Panel>
                        </div>
                    </div>
                    <div
                        className={`flex flex-column md:flex-row justify-content-end mt-5" 
                        } align-items-center`}
                    >
                        {Buttons(t, props.agreeCallback, props.declineCallback)}
                    </div>
                </div>
            }
        ></Dialog>
    );
};
